module.exports = __webpack_public_path__ + "img/underwriting_portal.fed20d22.png";